module.exports = __webpack_public_path__ + "img/pearson.8e74d48c.jpg";